import React, { useState, useEffect } from 'react';
import JobCard from './JobCard';
import LaravelApi from '../../components/laravelApi/LaravelApi';
import DateTimeTools from '../../tools/DateTimeTools';
import Spinner from '../../components/spinner/Spinner';
import { jobList } from '../../../fakeDatabase';

const JobList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    //const response = await LaravelApi.get('/jobs', {});
    setData(jobList);
  }

  if (data != null) {
    const companiesList = data.map(data => {
      var from   = DateTimeTools.getFormatedTimeFromString(data.from);
      var to     = DateTimeTools.getFormatedTimeFromString(data.to);
      
      return (
        <div className="column">
          <JobCard 
            key={data.company}
            company={data.company}  
            companyUrl={data.companyUrl}
            rol={data.rol}
            from={from}
            to={to} 
            img={data.img}
          />
        </div>
      )
    });

    return (
      <div>
        <div className="ui hidden divider"></div>
        <div className="ui container centered">
          <div className="ui stackable three column grid">
          {companiesList}
        </div>
        </div>
      </div>
    )
  }
  return (
    <Spinner />
  )
}

export default JobList;